import { useTranslation } from 'react-i18next';
import { ExpandableText } from '../CollapsibleText/ExpandableText';
import { ImagesContainer } from '../Image/ImagesContainer';
import { decodeSourceName } from '../../utils/decodeURI';
import styles from './PublicationCard.module.scss';

/**
 * Quoted parent-post block for PublicationCard.
 * Receives already-resolved text (translated or original) via `text`.
 */
const ParentPostBlock = ({ parentMessage, text, textClassName }) => {
  const { t } = useTranslation();

  if (!parentMessage) return null;

  const sourceName = decodeSourceName(parentMessage.source?.name);
  const sourceUrl = parentMessage.source?.url;

  return (
    <section className={styles.parentPostBlock} aria-label={t('Original post')}>
      {sourceName && (
        <span
          className={styles.parentSourceName}
          data-tooltip-id="parent-source-info"
          data-tooltip-content={`${sourceName}\n${sourceUrl ?? t('N/A')}`}
        >
          {sourceUrl ? (
            <a href={sourceUrl} target="_blank" rel="noreferrer" className={styles.parentSourceLink}>
              {sourceName}
            </a>
          ) : (
            sourceName
          )}
        </span>
      )}

      {parentMessage.images?.length > 0 && (
        <ImagesContainer images={parentMessage.images} showCount={3} />
      )}

      {text && (
        <ExpandableText
          length={120}
          text={text}
          textClassName={textClassName ?? styles.expandableText}
        />
      )}
    </section>
  );
};

export default ParentPostBlock;
